module.exports = {
  publicPath: '/home/ui',
  prefixPath: '/home/ui/',
};
